import { useState, useEffect } from 'react';
import { workflowService } from '@/services/features/WorkflowService';
import { useAuth } from '@/contexts/AuthContext';

export interface UseProgramTypeDashboardResult {
  programTypes: string[];
  loading: boolean;
  error: string | null;
}

export const useProgramTypeDashboard = (): UseProgramTypeDashboardResult => {
  const { hasuraToken } = useAuth();
  const [programTypes, setProgramTypes] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchProgramTypes = async () => {
      if (!hasuraToken) {
        setError('Authentication required');
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const response = await workflowService.getProgramTypeDashboard(hasuraToken);

        if (response.success) {
          setProgramTypes(response.data);
          setError(null);
        } else {
          setError(response.error || 'Failed to fetch program types');
        }
      } catch (err: any) {
        setError(err.message || 'Failed to fetch program types');
      } finally {
        setLoading(false);
      }
    };

    fetchProgramTypes();
  }, [hasuraToken]);

  return {
    programTypes,
    loading,
    error
  };
};
